import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { LangObj, Res } from '../models';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  // Params for Language
  languages: string[] = []; //['ru', 'kk', 'en']; 
  languagesObj: LangObj[] = [];
  defaultLanguage = 'ru';
  defaultLanguageObj = { code2: 'ru', code3: 'rus', digital_code: 570, default: true, name: 'Русский' }
  languageSubject = new Subject<any>();
  languagesSubject = new Subject<any>();
  subscribeStreamNbMenuItem: Subscription;
  mbMenuItemSubject = new Subject<any>();

  constructor(
    private translate: TranslateService,
    private api: ApiService,
  ) {}

  
  /**
   * Install Language on boot
   */
  installLanguageOnBoot(): void {

    this.translate.addLangs(this.languages);
    this.translate.setDefaultLang(this.defaultLanguage);

    let checkedLanguage: string = this.defaultLanguage;
    let languageInLocalStorage: string = localStorage.getItem('language');
    
    if(languageInLocalStorage && this.checkIfLanguageIsAvailable(languageInLocalStorage)){

      checkedLanguage = languageInLocalStorage;
    }
    else{

      localStorage.setItem('language', this.defaultLanguage);
      console.warn('[LANGUAGE]: В localStorage не установлен язык, по умолчанию устанавливаем: ' + this.defaultLanguage);
    }

    this.translate.use(checkedLanguage);
    this.selectLanguage(checkedLanguage);
  }


  /**
   * Select Language
   * @param value Language
   */
  selectLanguage(value: string): void {

    if(this.checkIfLanguageIsAvailable(value)){

      this.translate.use(value);
      localStorage.removeItem('language');
      localStorage.setItem('language', value);  
      
      this.languageSubject.next({language: value});
    }
    else{

      console.warn('[LANGUAGE]: Выбор языка не выполнен.');
    }
  }

  
  /**
   * Method to listen for language change
   * @returns Observable<any>
   */
  listenerLanguage(): Observable<any> {

    return this.languageSubject.asObservable();
  }


  /**
   * 
   * @returns Observable<any>
   */
  listenerLanguages(): Observable<any> {

    return this.languagesSubject.asObservable();
  }


  /**
   * 
   * @returns string
   */
  getLanguage(): string {
    
    let language = localStorage.getItem('language');
    
    if(language){
    
      return language;
    }

    return this.defaultLanguage;
  }


  /**
   * 
   */
  getLanguages(): void {
    // Apply local fallback immediately to avoid showing translation keys
    // while language API is loading or unavailable.
    this.languagesObj = [this.defaultLanguageObj];
    this.languages = [this.defaultLanguage];
    this.languagesSubject.next(this.languagesObj);
    this.installLanguageOnBoot();

    let subscriptions: Subscription = this.api.get('getLanguages').subscribe((response: Res) => { console.log('[RESPONSE] getLanguages: ', response);
      
      if(response != null){

        this.languages = [];
        this.languagesObj = response.result;
       
        response.result.forEach((value: LangObj) => {
          
          this.languages.push(value.code2);

          if(value.default) {
            
            this.defaultLanguage = value.code2;
            this.defaultLanguageObj = value;
          }
        });
      }
      else {

        this.languagesObj.push(this.defaultLanguageObj);
        this.languages.push(this.defaultLanguage);
      }

      this.languagesSubject.next(this.languagesObj);
      this.installLanguageOnBoot();

      subscriptions.unsubscribe();
    },
    error => { 
      // Fallback for local/dev mode when languages API is unavailable.
      this.languagesObj = [this.defaultLanguageObj];
      this.languages = [this.defaultLanguage];
      this.languagesSubject.next(this.languagesObj);
      this.installLanguageOnBoot();
      subscriptions.unsubscribe();
    });
  }


  /**
   * Проверить, доступен ли переданный язык в наборе 
   * @param lang 
   */
  checkIfLanguageIsAvailable(value: string): boolean {

    if(this.languages.indexOf(value) == -1){

      console.warn('[LANGUAGE]: Значение (' + value + ') отсутствует в наборе допустимых языков.');
      return false;
    }

    return true;
  }


  /**
    * Запрос мгновенного перевода текста по ключу из языкового json файла (можно вызывать только когда все данные загружены)
    * @param key ключ, который указан в языковом json файле
    */
  instant(key: string): string {

    return this.translate.instant(key);
  }

  
  /**
   * Запрос перевода текста по ключу из языкового json файла, работает по подписке, и реагирует на обновленя (изменение языка)
   * @param key 
   * @param params 
   */
  stream(key: string | string[], params?: Object): Observable<any> {

    return this.translate.stream(key, params);
  }
}
